import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/fbpixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    trackAddToCart();
    window.open('https://aeduclub.com/cart/47717954093274:1', '_blank');
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-gold hover:bg-gold-hover text-charcoal font-bold py-4 px-8 rounded-xl shadow-lg transition-colors text-lg md:text-xl w-full md:w-auto text-center flex justify-center items-center ${className}`} {...props} data-id="element-135">
      {children}
    </motion.button>;
}